import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { SimpleLoader } from '@dev/ee-components';

import { TransparentLoaderProps } from './TransparentLoaderInterface';

const Layout = styled.div`
    width: 100vw;
    height: 100vh;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.7);
    background: rgba(255, 255, 255, 0.7);
    z-index: 100;
`;

class TransparentLoader extends PureComponent<TransparentLoaderProps> {
    public render(): JSX.Element {
        return (
            <Layout>
                <SimpleLoader />
            </Layout>
        );
    }
}

export default TransparentLoader;
